import React, { useState, useEffect, useRef } from "react";


import api from "../../Services/api";
import PageDescriptionFootnote from "../Footnote";
const PageDescriptionDenuncias = (props: any) => {

    const [page, setLayoutPagina] = useState<any[]>([]);  

    useEffect(() => {
        api
        .get("/ObterLayoutPaginaFiltro?Identificador="+props.page)
            .then((response) => {

                setLayoutPagina(response.data.results);
                // //console.log("Page :", page);
            })
            .catch((err) => {
                throw new Error(err);
            });
    }, []);

    function renderObjectBody(data: any) {
        // //console.log("data :", data);
        return { __html: data }
    }



    return (

        <section className="page-description mb-9">
            <div className="container">
                <div className="row justify-content-center">

                {page?.filter(i => i.Identificador === props.page).map(item => (

                    <div className="col-lg-10">
                        <div className="page-description__form _form mb-lg-9 mb-7">
                            <h3> Importante! </h3>
                            <p>O Canal de Denúncias <strong>NÃO</strong> deve ser utilizado para dúvidas, reclamações, sugestões ou críticas relacionadas aos processos da Forluz. Nestes casos, você deve utilizar os Canais de Atendimento da Fundação:</p> 
                            <ul>
                                <li>0800-0909090</li>
                                <li>atendimento@forluz.org.br</li>
                                <li>Avenida do Contorno, 6500, 3° Andar - Lourdes, Belo Horizonte - MG (Atendimento presencial) </li>
                            </ul>
                            <hr />
                            <br></br>
                            <h3> Acompanhar ocorrência </h3>
                            <form action="../pages/canal-de-denuncia-registrar.html" className="row mt-5">
                                <div className="col-md-6 col-lg-5 mb-4 mb-md-0" style={{ display: "none" }}>
                                    <div className="box-busca position-relative"  >
                                        <input type="text" placeholder="Digite o Nº do protocolo" required />
                                        <span className="ico">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15 15L12 12" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-3">

                                    <a target="_blank" href="https://www.contatoseguro.com.br/forluz" className="btn btn-ocorrencia transition">Registrar ocorrência</a>
                                </div>
                            </form>
                        </div>

                        <div className="page-description__midias">
                            <PageDescriptionFootnote />
                        </div>
                        
                        <div className="page-description__title mb-lg-5">
                                {/* {item?.Corpo} */}
                                {item.Corpo &&
                                <> 
                                <br></br><br></br>
                                <span dangerouslySetInnerHTML={renderObjectBody(item.Corpo)} />
                                <hr></hr> </>}
                            </div>

                    </div>
                ))}

                </div>
            </div>
        </section>

    )
};
export default PageDescriptionDenuncias;
